import { useCurrentUser } from "../providers/CurrentUser";

import { adminOrganizationId } from "@/config/constants";

const useIsAdmin = () => {
  const user = useCurrentUser();
  return user?.organizationId === adminOrganizationId;
};

export default useIsAdmin;
